// import { BrowserRouter, Route, Routes } from "react-router-dom";
// import { ToastContainer, toast } from 'react-toastify'
// import "react-toastify/dist/ReactToastify.css";
// import Login from "./Components/loginFiles/Login";
// import ForgotPassword from "./Components/loginFiles/ForgotPassword";
// import ResetPassword from "./Components/loginFiles/RestPassword";
// import Dashboard from "./layout/Das";
// import Profile from "./Components/adminProfile/Profile";
// import EditProfile from "./Components/adminProfile/EditProfile";
// import User from "./Components/userFile/User";
// import Loader from "./Components/loader/LoaderFile";
// import ChangePassword from "./Components/changePasswordFile/ChangePassword";
// import PrivateRoutes from "./utils/PrivateRoutes";
// import Error from "./Components/errorFile/Error";
// import { routes } from "./constants/routes";
// import Session from "./Components/session/Session";
// import CreateSession from "./Components/session/CreateSession";
// import UpdateUser from "./Components/userFile/UpdateUser";
// import ViewUser from "./Components/userFile/ViewUser";
// import LiveSession from "./Components/lunchSession/LiveSession";
// import ViewSession from "./Components/session/ViewSession";
// import UpdateSession from "./Components/session/UpdateSession";
// import CreateUser from "./Components/userFile/CreateUser";
// import Complete from "./Components/session/Complete";
// import EditSop from "./Components/session/EditSop";
// import Question from "./Components/question/Question";
// import Faq from  "./Components/faq/Faq";
// import UnAuthenticatedRoutes from "./utils/UnAuthenticatedRoutes";



// function App() {
//   return (
//     <BrowserRouter>
//     <ToastContainer />
//       <Loader />
//         <Routes>
//         <Route exact element={<UnAuthenticatedRoutes/>}>
//           <Route exact path={routes.DEFAULT} element={<Login />} />
//           <Route path={routes.FORGOTPASSWORD} element={<ForgotPassword />} />
//           <Route path={routes.RESETPASSWORD} element={<ResetPassword />}/>
//           </Route>
//           <Route exact element={<PrivateRoutes />}>
//             <Route path={routes.DASHBOARD} element={<Dashboard />} />
//             <Route path={routes.PROFILE} element={<Profile />} />
//             <Route path={routes.EDITPROFILE} element={<EditProfile />} />            
//             <Route path={routes.USER} element={<User />} />
//             <Route path={routes.USER_CREATE_USER} element={<CreateUser/>} />
//             <Route path={routes.USER_UPDATE_USER} element={<UpdateUser />} />
//             <Route path={routes.USER_VIEW_USER} element={<ViewUser />} />
//             <Route path={routes.SESSION} element={<Session />} />
//             <Route path={routes.EDIT_SOP} element={<EditSop/>}/>
//             <Route path={routes.COMPLETE_SESSION} element={<Complete />} />
//             <Route path={routes.UPDATE_SESSION} element={<UpdateSession />} />
//             <Route path={routes.VIEW_SESSION} element={<ViewSession />} />
//             <Route path={routes.LIVE_SESSION} element={<LiveSession />} />
//             <Route path={routes.CREATE_SESSION} element={<CreateSession />} />
//             <Route path={routes.CHANGEPASSWORD} element={<ChangePassword />} />
//             <Route path={routes.QUESTION} element={<Question/>}/>
//             <Route path={routes.FAQ} element={<Faq/>}/>
//           </Route>
//           <Route path={routes.ERROR} element={<Error />} />
//         </Routes>
    
//     </BrowserRouter>
//   );
// }

// export default App;


import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./Components/loginFiles/Login";
import ForgotPassword from "./Components/loginFiles/ForgotPassword";
import ResetPassword from "./Components/loginFiles/RestPassword";
import Dashboard from "./layout/Das";
import Profile from "./Components/adminProfile/Profile";
import EditProfile from "./Components/adminProfile/EditProfile";
import User from "./Components/userFile/User";
import Loader from "./Components/loader/LoaderFile";
import ChangePassword from "./Components/changePasswordFile/ChangePassword";
import PrivateRoutes from "./utils/PrivateRoutes";
import Error from "./Components/errorFile/Error";
import { routes } from "./constants/routes";
import Session from "./Components/session/Session";
import CreateSession from "./Components/session/CreateSession";
import UpdateUser from "./Components/userFile/UpdateUser";
import ViewUser from "./Components/userFile/ViewUser";
import LiveSession from "./Components/lunchSession/LiveSession";
import ViewSession from "./Components/session/ViewSession";
import UpdateSession from "./Components/session/UpdateSession";
import CreateUser from "./Components/userFile/CreateUser";
import Complete from "./Components/session/Complete";
import EditSop from "./Components/session/EditSop";
import Question from "./Components/question/Question";
import Faq from "./Components/faq/Faq";
import UnAuthenticatedRoutes from "./utils/UnAuthenticatedRoutes";
import Video from "./Components/video/Video";
import CreateVideoSop from "./Components/video/CreateVideoSop";
import MergeVideos from "./Components/video/MergeVideo";
import KeyValue from "./Components/keyValue/KeyValue";

function App() {
  return (
    <BrowserRouter>
      <ToastContainer />
      <Loader />
      <Routes>
        {/* Unauthenticated Routes */}
        <Route element={<UnAuthenticatedRoutes />}>
          <Route path={routes.DEFAULT} element={<Login />} />
          <Route path={routes.FORGOTPASSWORD} element={<ForgotPassword />} />
          <Route path={routes.RESETPASSWORD} element={<ResetPassword />} />
        </Route>

        {/* Private Routes */}
        <Route element={<PrivateRoutes />}>
          <Route path={routes.DASHBOARD} element={<Dashboard />} />
          <Route path={routes.PROFILE} element={<Profile />} />
          <Route path={routes.EDITPROFILE} element={<EditProfile />} />
          <Route path={routes.USER} element={<User />} />
          <Route path={routes.USER_CREATE_USER} element={<CreateUser />} />
          <Route path={routes.USER_UPDATE_USER} element={<UpdateUser />} />
          <Route path={routes.USER_VIEW_USER} element={<ViewUser />} />
          <Route path={routes.SESSION} element={<Session />} />
          <Route path={routes.EDIT_SOP} element={<EditSop />} />
          <Route path={routes.COMPLETE_SESSION} element={<Complete />} />
          <Route path={routes.UPDATE_SESSION} element={<UpdateSession />} />
          <Route path={routes.VIEW_SESSION} element={<ViewSession />} />
          <Route path={routes.LIVE_SESSION} element={<LiveSession />} />
          <Route path={routes.CREATE_SESSION} element={<CreateSession />} />
          <Route path={routes.CHANGEPASSWORD} element={<ChangePassword />} />
          <Route path={routes.QUESTION} element={<Question />} />
          <Route path={routes.FAQ} element={<Faq />} />
          <Route path={routes.VIDEO} element={<Video/>}/>
          <Route path={routes.CREATE_VIDEO_Sop} element={<CreateVideoSop/>}/>
          <Route path={routes.MERGE_VIDEO} element={<MergeVideos/>} />
          <Route path={routes.KEY_VALUE} element={<KeyValue/>}/>

        </Route>

        {/* Error/Fallback Route */}
        <Route path={routes.ERROR} element={<Error />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
